import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminDeliveryOrder from "../component/admin/delivery-order/AdminDeliveryOrder";
import AdminMain from "../component/layout/AdminMain";
import Login from "../component/login/Login";
import PrivateRoute from "./PrivateRoute";

export default function DriverRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminMain />
          </PrivateRoute>
        }
      >
        <Route
          path="/admin/surat-jalan"
          element={
            <PrivateRoute>
              <AdminDeliveryOrder />
            </PrivateRoute>
          }
        />
      </Route>
    </Routes>
  );
}
